import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42fb6054"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base leave-container" }
const _hoisted_2 = { class: "footer-setting" }


export default /*#__PURE__*/_defineComponent({
  __name: 'NoAccessPopup',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



const leave = () => {
  window.location.href = 'https://app.globish.co.th/'
}

return (_ctx: any,_cache: any) => {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    title: _ctx.$t('zoom-diagnostic.access-denied.title'),
    open: __props.modelValue,
    "can-close": false
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-leave bg-red-500",
          onClick: leave
        }, _toDisplayString(_ctx.$t('zoom-diagnostic.access-denied.leave')), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('zoom-diagnostic.access-denied.message')), 1)
    ]),
    _: 1
  }, 8, ["title", "open"]))
}
}

})